import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TestPageMockState } from '../../showcase-mock-state'

/**
 * The production Retention Policy screen, fed by patched endpoints so its
 * capability-gated retained-recovery-points table is always visible here.
 */
@Component({
  selector: 'showcase-retention',
  templateUrl: './showcase-retention.component.html',
  styleUrls: ['./showcase-retention.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseRetentionComponent {
  // Remount latch: the production component loads its recovery points once in
  // ngOnInit, so replaying the mock list after a release means recreating it.
  retentionMounted = true

  constructor(private readonly state: TestPageMockState) {}

  resetRetentionMocks(): void {
    this.state.resetRetainedRecoveryPoints()
    this.retentionMounted = false
    setTimeout(() => (this.retentionMounted = true))
  }
}
